import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import Icon from '~/components/Icon'
import ContentBox, { BoxActionsHeader } from '~/components/layout/ContentBox'
import { Heading1 } from '~/components/typography/Titles'
import { Body } from '../typography/Content'
import { InviteTeamMemberForm } from './InviteTeamMemberForm'

export function InviteTeamMemberBox() {
  const { t } = useTranslations('home')

  return (
    <ContentBox
      scrollable={false}
      variant="default"
      contentContainerClassName="gap-4 px-0 pt-0"
      header={
        <BoxActionsHeader variant="default">
          <View className="flex-row items-baseline gap-2 px-4">
            <Icon name="people-outline" size={20} className="flex-none shrink-0 text-accent" />
            <Heading1 className="flex-auto text-center">
              {t(($) => $.realtor.inviteTeam.title)}
            </Heading1>
          </View>
        </BoxActionsHeader>
      }>
      <Body className="px-6 text-center text-base/normal text-primary">
        {t(($) => $.realtor.inviteTeam.description)}
      </Body>

      <InviteTeamMemberForm className="px-6 pb-2" />
    </ContentBox>
  )
}
